export type Indexed<T extends unknown> = T & { originalIndex: number }

export const filterAndPreserveIndex = <T>(
    array: T[],
    predicate: (value: Indexed<T>, index: number, array: T[]) => boolean,
): Indexed<T>[] => {
    return array.map((v, originalIndex) => ({ ...v, originalIndex })).filter(predicate)
}
